import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

function AuthGuard({ children }) {
  const account = useSelector(state => state.account);
  const user = account?.user ?? null;
  const roles = user?.roles ?? []; 

  if (!user) {
    return <Redirect to="/login" />;
  }

  if (
    roles.length > 0 &&
    roles[0].name === 'affiliate'
  ) {
    return <Redirect to="/affiliate" />;
  }

  if (
    roles.length > 0 &&
    roles[0].name === 'engineering'
  ) {
    return <Redirect to="/engineering" />;
  }

  if (
    roles.length > 0 &&
    roles[0].name === 'reviewer'
  ) {
    return <Redirect to="/reviewer" />;
  }

  if (roles.length > 0 && roles[0].name === 'fire') {
    return <Redirect to="/fire" />;
  }

  if (roles.length > 0 && roles[0].name === 'mpdo') {
    return <Redirect to="/mpdo" />;
  }

  if (roles.length > 0 && roles[0].name === 'admin') {
    return <Redirect to="/administrator" />;
  }

  if (
    roles.length > 0 &&
    roles[0].name === 'treasury'
  ) {
    return <Redirect to="/treasury" />;
  }

  if (
    roles.length > 0 &&
    roles[0].name === 'requirements-reviewer'
  ) {
    return <Redirect to="/requirements-reviewer" />;
  }

  if (
    roles.length > 0 &&
    roles[0].name === 'structural-reviewer'
  ) {
    return <Redirect to="/structural-reviewer" />;
  }

  if (
    roles.length > 0 &&
    roles[0].name === 'plumbing-reviewer'
  ) {
    return <Redirect to="/plumbing-reviewer" />;
  }

  if (
    roles.length > 0 &&
    roles[0].name === 'electrical-reviewer'
  ) {
    return <Redirect to="/electrical-reviewer" />;
  }

  if (
    roles.length > 0 &&
    roles[0].name === 'architectural-reviewer'
  ) {
    return <Redirect to="/architectural-reviewer" />;
  }

  if (
    roles.length > 0 &&
    roles[0].name === 'requirements-reviewer'
  ) {
    return <Redirect to="/requirements-reviewer" />;
  }

  if (
    roles.length > 0 &&
    roles[0].name === 'line-and-grade-reviewer'
  ) {
    return <Redirect to="/line-and-grade-reviewer" />;
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.any
};

export default AuthGuard;
